import { Outlet, Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, FileText, Plus } from "lucide-react";

export default function AdminLayout() {
    const { admin, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate("/admin/login", { replace: true });
    };

    return (
        <div className="min-h-screen bg-[#FBFAF8] flex flex-col" data-testid="admin-layout">
            <header className="bg-white border-b border-acre-line">
                <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between gap-6">
                    <div className="flex items-center gap-8">
                        <Link
                            to="/admin"
                            data-testid="admin-logo"
                            className="flex items-baseline gap-2 select-none"
                        >
                            <span className="font-serif-display text-2xl !text-acre-ink">
                                Chesterton
                            </span>
                            <span className="text-[10px] uppercase tracking-[0.28em] text-acre-muted">
                                Admin
                            </span>
                        </Link>
                        <nav className="flex items-center gap-6" aria-label="Admin">
                            <NavLink
                                to="/admin"
                                end
                                data-testid="admin-nav-posts"
                                className={({ isActive }) =>
                                    `text-[12px] uppercase tracking-[0.18em] transition-colors ${
                                        isActive ? "text-acre-secondary font-semibold" : "text-acre-ink hover:text-acre-secondary"
                                    }`
                                }
                            >
                                <span className="inline-flex items-center gap-2"><FileText size={13} /> Posts</span>
                            </NavLink>
                            <NavLink
                                to="/admin/new"
                                data-testid="admin-nav-new"
                                className={({ isActive }) =>
                                    `text-[12px] uppercase tracking-[0.18em] transition-colors ${
                                        isActive ? "text-acre-secondary font-semibold" : "text-acre-ink hover:text-acre-secondary"
                                    }`
                                }
                            >
                                <span className="inline-flex items-center gap-2"><Plus size={13} /> New</span>
                            </NavLink>
                        </nav>
                    </div>
                    <div className="flex items-center gap-4">
                        <Link
                            to="/"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="admin-view-site"
                            className="text-[11px] uppercase tracking-[0.2em] text-acre-muted hover:text-acre-ink transition-colors"
                        >
                            View site ↗
                        </Link>
                        <span className="hidden md:inline text-xs text-acre-muted">{admin?.email}</span>
                        <button
                            onClick={handleLogout}
                            data-testid="admin-logout"
                            className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-acre-ink border border-acre-line px-4 py-2 hover:border-acre-primary hover:text-acre-primary transition-colors"
                        >
                            <LogOut size={13} /> Sign out
                        </button>
                    </div>
                </div>
            </header>
            <main className="flex-1">
                <Outlet />
            </main>
        </div>
    );
}
